import React, { useEffect, useRef, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import styles from "./index.module.css";
import { main_server } from "../../constants";
import { Spotlight } from "../../ui/spotlight";
import { Sparkels } from "../";

const Login = (props) => {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [rem, setRem] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [redirect, setRedirect] = useState('/');

  const userRef = useRef();
  const passRef = useRef();
  const remRef = useRef();
  const forgotRef = useRef();
  const redirectRef = useRef();

  useEffect(() => {
    userRef.current = user;
    passRef.current = pass;
    remRef.current = rem;
    forgotRef.current = forgot;
    redirectRef.current = redirect;
  }, [user, pass, rem, forgot, redirect]);

  async function loginUser() {
    if (forgotRef.current) {
      const response = await fetch(
        main_server + "forgotPass",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            val: userRef.current
          }),
        },
      );
      const content = await response.text();
      if (response.status === 200) {
        props.setAlertType(true);
        props.setAlertText('Password Reset Email Sent !');
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      } else if (response.status === 400) {
        props.setAlertType(false);
        props.setAlertText(content);
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      } else {
        props.setAlertType(false);
        props.setAlertText(
          "Unexpected error, please try again later.",
        );
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      }
    } else {
      if (userRef.current.length < 3 || userRef.current.length > 32) {
        props.setAlertType(false);
        props.setAlertText(
          "Username should be between 3 and 32 charachters.",
        );
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
        return;
      }
      if (passRef.current.length < 8 || passRef.current.length > 64) {
        props.setAlertType(false);
        props.setAlertText(
          "Password should be between 8 and 64 charachters.",
        );
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
        return;
      }
      const response = await fetch(
        main_server + "login",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            user: userRef.current,
            pass: passRef.current,
            rem: remRef.current,
          }),
        },
      );
      const content = await response.text();
      if (response.status === 200) {
        localStorage.setItem("chesscloud-token", content);
        document.cookie = `chesscloud-token=${content}; domain=.chessmind.io; path=/; max-age=31536000`;
        window.location.href = redirectRef.current;
      } else if (response.status === 406) {
        props.setAlertType(false);
        props.setAlertText(content);
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      } else if (response.status === 501) {
        props.setAlertType(false);
        props.setAlertText(
          "Error while sending SMS, please try again later.",
        );
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      } else if (response.status === 403) {
        props.setAlertType(false);
        props.setAlertText("User not found.");
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      } else {
        props.setAlertType(false);
        props.setAlertText(
          "Unexpected error, please try again later.",
        );
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      }
    }
  }

  const login = useGoogleLogin({
    redirect_uri: "https://analysis.chessmind.io:",
    onSuccess: async (codeResponse) => {
      const response = await fetch(
        main_server + "google_login",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            token: codeResponse.access_token,
          }),
        },
      );
      const content = await response.text();
      if (response.status === 200) {
        localStorage.setItem("chesscloud-token", content);
        document.cookie = `chesscloud-token=${content}; domain=.chessmind.io; path=/; max-age=31536000`;
        window.location.href = '/confirm';
      } else if (response.status === 406) {
        props.setAlertType(false);
        props.setAlertText("User not found ! Please register.");
        props.setShowAlert(true);
        setTimeout(() => props.setShowAlert(false), 3000);
      }
    },
  });

  function handleKeyDown(e) {
    if (e.key == 'Enter') {
      loginUser();
    }
  }

  useEffect(() => {
    props.setSelected(2);
    props.setShow(true);
    var query = window.location.search;
    if (query.includes('?redirect=/')) {
      const dt = query.split('?redirect=/')[1];
      setRedirect(dt);
    }
    document.addEventListener("keydown", handleKeyDown);
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  return (
    <section className={`${styles.container} absolute top-0 pt-[75px] w-full h-full left-0`}>
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-2xl mx-auto">
          <div className={styles.cardWrapper}>
            <Spotlight
              className="-top-40 left-0 md:left-60"
              fill="white"
              active={true}
            />
            <div className={`${styles.card} text-center`}>
              <h1 className={styles.title}>
                {forgot ? "Reset Password" : "Sign In"}
              </h1>
              <Sparkels />
              <p className={styles.subtitle}>
                {forgot
                  ? "You'll receive instructions to reset your password to your email address"
                  : "WELCOME TO CHESSMIND !"}
              </p>
          {!forgot && (
            <>
              <div className="mt-8">
                <button
                  type="button"
                  onClick={() => login()}
                  className={styles.googleButton}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="w-5 h-5"
                    src="https://landingfoliocom.imgix.net/store/collection/clarity-dashboard/images/previews/sign-in/1/google-logo.svg"
                    alt=""
                  />
                  {props.lang === 0 ? "התחברו עם גוגל" : "Sign in with Google"}
                </button>
              </div>
              <div className={styles.divider}>
                <div className="flex justify-center">
                  <span className={styles.dividerText}>
                    or
                  </span>
                </div>
              </div>
            </>
          )}

          <form className="mt-4">
            <div className={styles.formGrid}>
              <div
                className={`flex items-center ${props.lang === 0 ? "justify-end" : "justify-start"}`}
              >
                <label
                  htmlFor="email"
                  className={styles.label}
                >
                  {props.lang === 0 ? "איימיל" : "Email"}
                </label>
              </div>
              <div className="mt-2">
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => setUser(e.target.value)}
                  placeholder={
                    props.lang === 0
                      ? "שם משתמש / כתובת איימיל"
                      : "Username / Email address"
                  }
                  value={user}
                  className={`${styles.input} ${props.lang === 0 && "text-right"}`}
                />
              </div>

              <div>
                {!forgot && (
                  <>
                    <div
                      className={`flex items-center ${props.lang === 0 ? "justify-end" : "justify-between"}`}
                    >
                      <label htmlFor="password" className={styles.label}>
                        {props.lang === 0 ? "סיסמא" : "Password"}
                      </label>
                    </div>
                    <div className="mt-2">
                      <input
                        type="password"
                        name="password"
                        id="password"
                        onChange={(e) => setPass(e.target.value)}
                        placeholder={
                          props.lang === 0
                            ? "סיסמא (לפחות 8 תווים)"
                            : "Password (min. 8 character)"
                        }
                        value={pass}
                        className={`${styles.input} ${props.lang === 0 && "text-right"}`}
                      />
                    </div>
                  </>
                )}
                <a
                  onClick={() => setForgot(!forgot)}
                  title=""
                  className={`${styles.link} flex items-center justify-end mt-[20px]`}
                  style={{ cursor: 'pointer' }}
                >
                  {" "}
                  {forgot
                    ? props.lang === 0
                      ? "חזרה להתחברות"
                      : "Back to Login"
                    : props.lang === 0
                      ? "שכחתי סיסמא"
                      : "Forgot Password?"}{" "}
                </a>
              </div>

              {!forgot && (
                <>
                  <div
                    className={`relative flex items-center ${props.lang === 0 && "justify-end"}`}
                  >
                      <div className="flex items-center h-5">
                        <input
                          type="checkbox"
                          checked={rem}
                          onChange={() => setRem(!rem)}
                          name="remember-password"
                          id="remember-password"
                          className={styles.checkbox}
                        />
                      </div>

                    <div className="ml-3">
                      <label
                        htmlFor="remember-password"
                        className={styles.checkboxLabel}
                      >
                        {props.lang === 0 ? "זכור אותי" : "Remember Me"}
                      </label>
                    </div>
                    
                  </div>
                </>
              )}

              <div>
                <div
                  onClick={() => loginUser()}
                  className={styles.button}
                  style={{ cursor: 'pointer' }}
                >
                  {forgot
                    ? props.lang === 0
                      ? "איפוס סיסמא"
                      : "Reset Password"
                    : props.lang === 0
                      ? "התחברות"
                      : "Sign in"}
                </div>
              </div>
            </div>
          </form>
          <div className="mt-6 text-center">
            {!forgot && (
              <p className={styles.checkboxLabel}>
                {props.lang === 0
                  ? "אין לכם חשבון עדיין"
                  : "Don't have an account?"}
                {props.lang === 0 && " ?"}
                <a
                  href="/register"
                  title=""
                  className={styles.link}
                  style={{ fontWeight: 'bold', cursor: 'pointer' }}
                >
                  {" "}
                  {props.lang === 0 ? "הירשמו עכשיו" : "Sign up now"}{" "}
                </a>
              </p>
            )}
          </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
